// extracted by mini-css-extract-plugin
export var fullWidthButton = "_za-0";
export var tagInputDisabled = "_za-1";